import {ChangeDetectionStrategy, Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges, ViewChild, AfterViewInit, HostListener } from '@angular/core';
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { DefaultDraftItem } from '../../../models/default-draft-template.model';

require('./planning-default-drafts-table.scss');
@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
  selector: 'app-planning-default-drafts-table',
  templateUrl: './planning-default-drafts-table.html',
})
export class PlanningDefaultDraftsTableComponent implements OnInit, OnChanges, AfterViewInit {
  @Input() drafts: DefaultDraftItem[] = [];

  // TODO: Restore edit functionality when draft names become editable
  // @Output() editDraft = new EventEmitter<DefaultDraftItem>();
  @Output() deleteDraft = new EventEmitter<DefaultDraftItem>();
  @Output() fetchNextEvent = new EventEmitter<void>();

  @ViewChild(CdkVirtualScrollViewport, { static: false })
  private cdkVirtualScrollViewport: CdkVirtualScrollViewport;

  public isScrollable: boolean;
  public displayAsItems: boolean;
  private isLoadingMore = false;

  constructor() {
    this.getScreenSize();
  }

  @HostListener('window:resize', ['$event'])
  getScreenSize(event?) {
    this.displayAsItems = window.innerWidth < 600;
    this.isScrollable = this.displayAsItems;
  }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.drafts) {
      // Reset loading flag when new data arrives
      this.isLoadingMore = false;
      this.cdkVirtualScrollViewport?.checkViewportSize();
    }
  }

  ngAfterViewInit(): void {
    if (!this.displayAsItems) {
      const div1 = document.getElementById('header');
      const div2 = document.querySelectorAll('.cdk-virtual-scroll-viewport')[0];

      if (div1 && div2) {
        div2.addEventListener('scroll', e => {
          div1.scrollTop = div2.scrollTop;
          div1.scrollLeft = div2.scrollLeft;
        });
      }
    }
  }

  getNextBatch(): void {
    if (this.isLoadingMore) return;
    
    if (this.cdkVirtualScrollViewport && this.cdkVirtualScrollViewport.measureScrollOffset('bottom') < 50) {
      this.isLoadingMore = true;
      this.fetchNextEvent.emit();
    }
  }

  trackByDraftId(index: number, draft: DefaultDraftItem): string {
    return draft?.id || index.toString();
  }

  // TODO: Restore edit functionality when draft names become editable
  // onEditDraft(draft: DefaultDraftItem): void {
  //   this.editDraft.emit(draft);
  // }

  onDeleteDraft(draft: DefaultDraftItem): void {
    this.deleteDraft.emit(draft);
  }
}
